import React, { useRef, useEffect } from "react";

const Menu = ({ anchorRef, open, onClose, options, onOptionClick, position }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        (!anchorRef || !anchorRef.current.contains(event.target))
      ) {
        onClose();
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, anchorRef, onClose]);

  if (!open || !position) return null;

  const menuStyle = {
    position: 'fixed',
    top: `${position.top}px`,
    left: `${position.left}px`,
    zIndex: 1000,
    minWidth: '224px', // Ensure consistent width with calculation in SmallHeader
  };

  return (
    <div
      ref={menuRef}
      className="w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
      style={menuStyle}
    >
      <div className="py-1">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => onOptionClick(option)}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Menu;
